"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EnumScreenNames_1 = require("../enums/EnumScreenNames");
exports.default = {
    staticPages: {
        screenName: "staticPageScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.HOME_PAGE]: {
        screenName: "HomeScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.ADD_FREE_POST]: {
        screenName: "AddFreePostScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.LANDING_PAGE]: {
        screenName: "ChooseSubCategoryScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.SHOP_DETAILS_SCREEN]: {
        screenName: "ShopScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.SHOP_LISTING_SCREEN]: {
        screenName: "ShopsListingScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.POST_VIEW_SCREEN]: {
        screenName: "PostViewScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.MID_SCREEN]: {
        screenName: "MidScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.WEATHER_SCREEN]: {
        screenName: "WeatherPageScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.PRAYER_TIME_SCREEN]: {
        screenName: "PrayerTimesPageScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.SAFETY_TIPS_SCREEN]: {
        screenName: "safetyTipsScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.SALES_REPRESENTATIVES]: {
        screenName: "salesContactsScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.ADVERTISING_PRODUCTS]: {
        screenName: "VasPageScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.POST_VIEW_SCREEN]: {
        screenName: "PostViewScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.OPENSOOQ_LOGO_SCREEN]: {
        screenName: "OpenSooqLogoPageScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.CAR_PRICES_SCREEN]: {
        screenName: "CarsSpecsLanding",
    },
    [EnumScreenNames_1.EnumScreenNames.AUTOS_SERVICE_SCREEN]: {
        screenName: "AutoServiceLanding",
    },
    selectCountryScreen: {
        screenName: "SelectCountryScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.SUPPORT_INDEX_SCREEN]: {
        screenName: "HelpCenterScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.CONTACT_US_SCREEN]: {
        screenName: "ContactUsScreen",
    },
    contactUsFormScreen: {
        screenName: "ContactUsFormScreen",
    },
    thanks4uFeedbackScreen: {
        screenName: "SuccessCustomerSupportScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.SUPPORT_FAQ_SCREEN]: {
        screenName: "FAQ_Articles_Screen",
    },
    [EnumScreenNames_1.EnumScreenNames.SERP_SCREEN]: {
        screenName: "SearchScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.TAGS_DETAILS]: {
        screenName: "SearchScreen",
    },
    [EnumScreenNames_1.EnumScreenNames.CAR_FAX_SCREEN]: {
        screenName: "carfax_screen",
    },
    midFollowersScreen: {
        screenName: "MIDFollowersScreen",
    },
    advertisingProductsPremium: {
        screenName: "advertising-products-Premium-package",
    },
    advertisingProductsVip: {
        screenName: "advertising-products-Vip-package",
    },
    advertisingProductsBumpup: {
        screenName: "advertising-products-Bumpup-package",
    },
    advertisingProductsTurbo: {
        screenName: "TurboAdPageScreen",
    },
    advertisingProductsElas: {
        screenName: "ElasPageScreen",
    },
    advertisingProductsWallet: {
        screenName: "WalletLandingPage",
    },
    boostAdPackagesPage: {
        screenName: "BoostAdSelectPackageScreen",
    },
    downloadAppScreen: {
        screenName: "DownloadAppScreen",
    },
    slrMainScreen: {
        screenName: "SLRMainScreen",
    },
    slrSuccessScreen: {
        screenName: "SLRSuccessScreen",
    },
    slrLoginScreen: {
        screenName: "SLRLoginScreen",
    },
    slrCompleteInfoScreen: {
        screenName: "SLRCompleteInfoScreen",
    },
    slrLoginOTPScreen: {
        screenName: "SLRLoginOTPScreen",
    },
    slrCompleteLoginOTPScreen: {
        screenName: "SLRCompleteLoginOTPScreen",
    },
    slrAddEditPhoneScreen: {
        screenName: "SLRAddEditPhone",
    },
    slrResetPassScreen: {
        screenName: "SLRResetPassScreen",
    },
    slrSMSPendingScreen: {
        screenName: "SLRSMSPendingScreen",
    },
    slrResetScreen: {
        screenName: "SLRResetScreen",
    },
    slrErrorScreen: {
        screenName: "SLRErrorScreen",
    },
    slrRegistrationScreen: {
        screenName: "SLRRegistrationScreen",
    },
    slrVIBPendingScreen: {
        screenName: "SLRVIBPendingScreen",
    },
    editProfileScreen: {
        screenName: "EditProfileScreen",
    },
    nextPageScreen: {
        screenName: "LoadMore_SearchScreen",
    },
};
